var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row mt-4 virtual-account"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_vm.show ? _c('b-form', {
    on: {
      "submit": _vm.onSubmit,
      "reset": _vm.onReset
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "bg-info p-3"
  }, [_c('h5', {
    staticClass: "card-title mb-0 font-weight-bold"
  }, [_vm._v(" Virtual Account Data ")])]), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-form-group', {
    attrs: {
      "id": "input-email",
      "label": "Email",
      "label-for": "email"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "email",
      "type": "email",
      "placeholder": "example@gmail.com",
      "required": ""
    },
    model: {
      value: _vm.form.email,
      callback: function ($$v) {
        _vm.$set(_vm.form, "email", $$v);
      },
      expression: "form.email"
    }
  })], 1)], 1), _c('div', {
    staticClass: "col-12"
  }, [_c('b-form-group', {
    attrs: {
      "id": "input-number",
      "label": "Virtual Account Number",
      "label-for": "number",
      "description": "Virtual Account Number is obtained from transfer receipt."
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "number",
      "type": "text",
      "placeholder": "Enter number",
      "required": ""
    },
    model: {
      value: _vm.form.number,
      callback: function ($$v) {
        _vm.$set(_vm.form, "number", $$v);
      },
      expression: "form.number"
    }
  })], 1)], 1), _c('div', {
    staticClass: "col-12"
  }, [_c('b-button', {
    staticClass: "mr-3 text-white",
    attrs: {
      "type": "submit",
      "variant": "info"
    }
  }, [_vm._v("Search Data")])], 1)])])])]) : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }